// import { useEffect } from "react";
import { NextPagePayloadInfo } from "../../config/types";
import SuccessScreen from "../../flow/interstitials/SuccessScreen";
import useAgentHandlerLinkModalContext from "../context/useAgentHandlerLinkModalContext";

export type Props = {
  linkingFlowPayload: NextPagePayloadInfo;
};

const ConnectedScreen = ({ linkingFlowPayload }: Props) => {
  const { onExit, getNextPageAndSetPage } =
    useAgentHandlerLinkModalContext();
  
  const shouldCallNextPage = linkingFlowPayload.should_call_next_page ?? false;

  return (
    <SuccessScreen
      connector={linkingFlowPayload?.connector}
      onClickBottomAction={() =>
        shouldCallNextPage
          ? getNextPageAndSetPage({})
          : onExit()
      }
    />
  );
};

export default ConnectedScreen;
